import { fetchEventSource } from "@microsoft/fetch-event-source";
import Logger from "../utils/logger";
let sseCtrl : any = null;

export function stopSseRequest (){
    if (sseCtrl) {
        sseCtrl.abort();
    }
}

export async function sseRequest (url : string, body : object, onMessage : (data : Response) => void, onError : (data : any) => void, onClose : () => void) {
    try {
        sseCtrl = new AbortController();
        await fetchEventSource(
            url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: "text/event-stream",
            },
            body: JSON.stringify(body),
            signal: sseCtrl.signal,
            async onopen(res) {
                if (res.ok && res.status === 200) {
                    Logger.log("Connection made ", res);
                } else if (
                    res.status >= 400 &&
                    res.status < 500 &&
                    res.status !== 429
                ) {
                    Logger.error("SSE client side error", res);
                    onError(res)
                }
            },
            onmessage(event) {
                let parsedData = {}
                try {
                    parsedData = JSON.parse(event.data);
                    onMessage(parsedData as Response)
                } catch (e) {
                    onError("cat't parse response as JSON")
                }
            },
            onclose() {
                onClose();
                Logger.log("Connection closed by the server");
            },
            onerror(err) {
                Logger.error("sse error:", err)
                throw err; // rethrow to stop the operation
            },
        });
    } catch (e) {
        onError(null)
    }
}